module.exports = __webpack_public_path__ + "static/media/fvcloud-logo-sm.d0106cfa.png";